import md5 from 'md5';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CallControls from '../components/CallControls';
import Dialler from '../components/Dialler';
import { getAudioDevices, testCanChangeAudioDevice, } from '../helpers/getAudioDevices';
import { answerCall, endCall } from '../reducers/calls';
import styles from '../styles/activeCall.scss';
import Monogram from './Monogram';
import Tag from './Tag';
import TimeElapsed from './TimeElapsed';
import { HangUpIcon, PhoneIcon } from './icons';
const ActiveCall = () => {
    const dispatch = useDispatch();
    const selectedAudioInputDeviceId = useSelector((state) => state.client.selectedAudioInputDeviceId);
    const selectedAudioOutputDeviceId = useSelector((state) => state.client.selectedAudioOutputDeviceId);
    const selectedRingingOutputDeviceId = useSelector((state) => state.client.selectedRingingOutputDeviceId);
    const activeCall = useSelector((state) => state.calls.find((c) => c.active === true));
    const ringingCall = useSelector((state) => state.calls.find((c) => c.answering || (c.ringing && c.direction === 'IN')));
    const call = activeCall || ringingCall;
    const [selectedAudioInputDevice, setSelectedAudioInputDevice] = useState(null);
    const [selectedAudioOutputDevice, setSelectedAudioOutputDevice] = useState(null);
    const [canChangeAudioDevice, setCanChangeAudioDevice] = useState(false);
    useEffect(() => {
        const canChangeAudioDevice = testCanChangeAudioDevice();
        getAudioDevices({
            selectedAudioInputDeviceId,
            selectedAudioOutputDeviceId,
            selectedRingingOutputDeviceId,
        })
            .then((devices) => {
            const { selectedAudioInputDevice, selectedAudioOutputDevice } = devices;
            setSelectedAudioInputDevice(selectedAudioInputDevice);
            setSelectedAudioOutputDevice(selectedAudioOutputDevice);
            setCanChangeAudioDevice(canChangeAudioDevice);
        })
            .catch(() => {
            setSelectedAudioInputDevice(null);
            setSelectedAudioOutputDevice(null);
            setCanChangeAudioDevice(canChangeAudioDevice);
        });
    }, []);
    const { answered, answering, ringing, name, number, direction, email, tags, started, description, id, diallerVisible, transferInitiated, } = call || {};
    // TODO fix gravatar size
    const usingMonogram = !email;
    const backgroundImgSrc = !usingMonogram && `https://www.gravatar.com/avatar/${md5(email)}`;
    const backgroundImgStyles = {
        backgroundImage: `url(${backgroundImgSrc})`,
    };
    const open = diallerVisible || transferInitiated;
    const inboundCall = direction === 'IN';
    let showSplitButtons = false;
    if (inboundCall && ringing && !answering) {
        showSplitButtons = true;
    }
    const nameEl = React.createElement("span", { className: styles.name }, name || number);
    const descriptionEl = (React.createElement("span", { className: styles.description },
        description && (React.createElement("span", { className: styles.description_text }, description)),
        (tags || []).map((t, i) => (React.createElement(Tag, { key: i, label: t })))));
    const infoEl = started ? (React.createElement(TimeElapsed, { start: started, autoUpdate: true })) : (React.createElement("span", null, inboundCall ? 'Incoming' : 'Calling'));
    const hasTags = (tags || []).length > 0;
    return (React.createElement("div", { className: styles.call_wrapper },
        React.createElement("div", { className: styles.call_container },
            usingMonogram ? (React.createElement("div", { className: styles.background_image_user },
                React.createElement(Monogram, null))) : (React.createElement("div", { className: styles.background_image_user, style: backgroundImgStyles })),
            React.createElement("div", { className: open ? styles.content_open : styles.content },
                React.createElement("div", { className: styles.info },
                    React.createElement("div", { className: styles.image_text_container },
                        React.createElement("div", { className: styles.image_container }, usingMonogram ? (React.createElement("div", { className: styles.image },
                            React.createElement(Monogram, null))) : (React.createElement("img", { alt: '', className: styles.image, src: `${backgroundImgSrc}?s=500` }))),
                        hasTags ? (React.createElement("div", { className: styles.details_container_tags },
                            React.createElement("div", { className: styles.first_row },
                                nameEl,
                                infoEl),
                            React.createElement("div", { className: styles.second_row }, descriptionEl))) : (React.createElement("div", { className: styles.details_container },
                            React.createElement("div", { className: styles.text_container },
                                nameEl,
                                descriptionEl),
                            React.createElement("div", { className: styles.time_container }, infoEl)))),
                    React.createElement("div", { className: styles.dialler_container }, transferInitiated ? React.createElement(Dialler, { transfer: true }) : React.createElement(Dialler, { inCall: true }))))),
        answered ? (React.createElement("div", { className: styles.controls_container },
            React.createElement(CallControls, null))) : (''),
        showSplitButtons ? (React.createElement("div", { className: styles.button_container },
            canChangeAudioDevice &&
                (!selectedAudioInputDevice || !selectedAudioOutputDevice) ? (React.createElement("div", { className: styles.button_answer_disabled, title: 'No audio input/output device connected' },
                React.createElement(PhoneIcon, null))) : (React.createElement("div", { className: styles.button_answer, onClick: () => {
                    if (id) {
                        dispatch(answerCall(id));
                    }
                } },
                React.createElement(PhoneIcon, null))),
            React.createElement("div", { className: styles.button_reject, onClick: () => {
                    if (id) {
                        dispatch(endCall(id));
                    }
                } },
                React.createElement(HangUpIcon, null)))) : (React.createElement("div", { className: styles.button_container },
            React.createElement("div", { className: styles.button_end, onClick: () => {
                    if (id) {
                        dispatch(endCall(id));
                    }
                } },
                React.createElement(HangUpIcon, null))))));
};
export default ActiveCall;
